import { render, staticRenderFns } from "./piedata.vue?vue&type=template&id=686b601b&"
import script from "./piedata.vue?vue&type=script&lang=ts&"
export * from "./piedata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports